<template>
  <wrapper-swiper :options="swiperOptions">
    <div class="swiper-slide"
      v-for="feature in featuredCards"
      :key="feature.id"
    >
      <featured-card
        :id="feature.id"
        :title="feature.title"
        :items="feature.items"
        :loading="feature.loading"
      />
    </div>
  </wrapper-swiper>
</template>

<script>
import FeaturedCard from './FeaturedCard.vue'
import { videosIusa, locationsIusa } from '../../services/featuredCardData.js'
import WrapperSwiper from '../WrapperSwiper.vue';
import axios from 'axios';

export default {
  components: {
    FeaturedCard,
    WrapperSwiper
  },

  data() {
    return {
      featuredCards: [
        {
          id: 'videosIusa',
          title: 'Videos IUSA',
          items: videosIusa,
        },
        {
          id: 'locationsIusa',
          title: 'Ubicaciones IUSA',
          items: locationsIusa,
        },
        // {
        //   id: 'tipsIusa',
        //   title: 'Tips del Día',
        //   items: [],
        //   loading: false,
        // },
      ],
      swiperOptions: {
        spaceBetween: 20,
        watchOverflow: true,
        breakpoints: {
          770: { slidesPerView: 2 },
          // 1500: { slidesPerView: 3 },
        },
      },
    }
  },

  mounted() {
    /**
     *  Cybersecurity tips requests and the tipsIusa object are temporarily disabled 
     *  because the platform has not been released yet and will remain disabled until further notice.
     */
    // this.getSlides();
  },

  methods: {
    async getSlides(){
      const cybersecurityUrl = process.env.VUE_APP_CYBERSECURITY_URL;
      const card = this.featuredCards.find(card => card.id === 'tipsIusa');
      card.loading = true;
      try {
        const response = await axios.get(`${cybersecurityUrl}/api/slides`);
        card.items = response.data.data;        
        card.loading = false;        
      } catch {
        // Delete Card
        const index = this.featuredCards.indexOf(card);

        if (index !== -1) {
          this.featuredCards.splice(index, 1);
        }

        this.$swal({
          title: 'Ocurrió un error al obtener los tips del día.',
          icon: 'error'
        });
      }      
    }
  },
}
</script>